import { z } from 'zod';

import { AttachVehicleFormResponseModel } from '../repo/types/AttachVehicleFormResponseModel';

const formResponseSchema: z.ZodType<AttachVehicleFormResponseModel> = z.object({
  name: z.string(),
  message: z.string(),
});

export function parseFormResponse(
  response: unknown,
): AttachVehicleFormResponseModel {
  return formResponseSchema.parse(response);
}
